import {InfoEntry, TFaqSection, TMetaData} from '.'

const MetaData: TMetaData = {
  title: 'ଫ୍ରି ଗେମ୍ସ ଅନଲାଇନ୍ ଖେଳନ୍ତୁ ବିନା ଡାଉନଲୋଡ୍ | Gamezop',
  desc: 'ଫ୍ରି ଅନଲାଇନ୍ ଗେମ୍ସ ଡାଉନଲୋଡିଂ ବିନା ଖେଳନ୍ତୁ Gamezop ରେ। ଏଠାରେ ଅଛି 200+ ଫ୍ରି ଗେମ୍ସ, ଯେଉଁଥିରେ ଅଛି ଆକ୍ସନ୍, ଆଡଭେଞ୍ଚର୍, ଆର୍କେଡ୍, ପଜଲ୍, ରେସିଂ ଓ ଅଧିକ। ଏବେଠାରୁ ଖେଳନ୍ତୁ!',
}

const InfoData: InfoEntry[] = [
  {
    tag: 'h1',
    title: 'ଫ୍ରି ଗେମ୍ସ ଅନଲାଇନ୍ ଖେଳନ୍ତୁ ବିନା ଡାଉନଲୋଡ୍',
    body: {
      text: [
        `Gamezop ଆପଣଙ୍କୁ ଡାଉନଲୋଡ୍ ବିନା ଖେଳିପାରା ସର୍ବୋତ୍ତମ ଫ୍ରି ଅନଲାଇନ୍ ଗେମ୍ସ ପ୍ରଦାନ କରେ। କେବଳ ଆପଣଙ୍କ ପସନ୍ଦର ଗେମ୍ସ ତାଲିକାରୁ ଚୟନ କରନ୍ତୁ ଓ କିଛି ସେକେଣ୍ଡ ମଧ୍ୟରେ ଖେଳା ଆରମ୍ଭ କରନ୍ତୁ। ଆମ ପାଖରେ 200+ ପ୍ରଚଳିତ ଫ୍ରି ଗେମ୍ସ ଅଛି, ଯାହା ଆକ୍ସନ୍, ଆଡଭେଞ୍ଚର୍, ଆର୍କେଡ୍, ପଜଲ୍, ରେସିଂ, ଓ ଅନ୍ୟାନ୍ୟ ବିଭାଗରେ ବିଭକ୍ତ। ଆପଣ ମୋବାଇଲ୍, PC ଓ iOS ଗେମ୍ସ ଖୋଜୁଥିବା ସମୟରେ, ଆମେ ଆପଣଙ୍କ ପାଇଁ ସର୍ବୋତ୍ତମ ଫ୍ରି ଗେମ୍ସ ଦେଇଥାଉ। ଆଲସ ଲାଗୁଥିଲେ, Gamezop ଆପଣଙ୍କ ମନୋରଞ୍ଜନ ପାଇଁ ଅସୀମ ଅବସର ଦେଉଛି। ଆମ ପାଖରେ ନୂଆ ଗେମ୍ସ ମଧ୍ୟ ଅଛି, ଯାହା ଆପଣଙ୍କୁ ପ୍ରତ୍ୟେକ ଖେଳରେ ଏକ ନୂଆ ଅନୁଭବ ଦେଉଛି। ପ୍ରତ୍ୟେକ ଗେମ୍ ଏକ ନୂଆ ଆଡଭେଞ୍ଚର୍ ଆଣି ଥାଏ!`,
        `ଯଦି ବୋର୍ ଲାଗୁଥାଏ, Gamezop ଆପଣଙ୍କ ପାଇଁ ଅସୀମ ମଜା ଏବଂ ଭଲ ଅଭିଜ୍ଞତା ନେଇଆସିଛି। Kingdom Fight, City Cricket, Fruity Fiesta ଭଳି ରୋମାଞ୍ଚକ ଗେମ୍ ଖେଳନ୍ତୁ। ଏହି ଗେମ୍ ପିଲା, ବଡ଼ ଏବଂ ବୃଦ୍ଧ ଲୋକଙ୍କ ପାଇଁ ଉପଯୁକ୍ତ।`,
        `ଏମାନେ ଖେଳିବାକୁ ଆପଣଙ୍କୁ ମହଙ୍ଗା ଡିଭାଇସ୍ ଦରକାର ନାହିଁ। ବ୍ରାଉଜର୍ ଏବଂ ଇଣ୍ଟରନେଟ୍ ଥିଲେ ଡେସ୍କଟପ୍, ଲ୍ୟାପଟପ୍, କ୍ରୋମବୁକ୍, ସ୍ମାର୍ଟଫୋନ୍, ଟାବଲେଟ୍ ଇତ୍ୟାଦି ଉପରେ ଏହି ଗେମ୍ ଖେଳିପାରିବେ।`,
      ],
      list: [],
    },
    links: {
      'Kingdom Fight': {
        type: 'game',
        name: 'Kingdom Fight',
        code: 'SyfxJ3a75Cr',
      },
      'City Cricket': {
        type: 'game',
        name: 'City Cricket',
        code: 'HJP4afkvqJQ',
      },
      'Fruity Fiesta': {
        type: 'game',
        name: 'Fruity Fiesta',
        code: 'mKZZW9NXW',
      },
    },
  },
  {
    tag: 'h2',
    title: 'ବେଷ୍ଟ ଫ୍ରି ଅନଲାଇନ୍ ଗେମ୍ସ କଣ କଣ?',
    body: {
      text: [],
      list: [
        {
          name: 'Bubble Wipeout',
          code: 'H1AN6fkwqJ7',
          type: 'game',
        },
        {
          name: 'Mahjong At Home: Scandinavian Edition',
          code: 'JVhRZNwly',
          type: 'game',
        },
        {
          name: 'Merge Mania',
          code: 'hfPOimYqY',
          type: 'game',
        },
        {
          name: 'Chef Tycoon',
          code: 'xqO4nZ6Kt',
          type: 'game',
        },
        {
          name: 'Cyberfusion',
          code: 'HJXei0j',
          type: 'game',
        },
        {
          name: 'Mafia Billiard Tricks',
          code: 'SkkV6MJD51Q',
          type: 'game',
        },
        {
          name: 'Spider Solitaire',
          code: 'B1MfIa4QCg',
          type: 'game',
        },
        {
          name: 'Basket Champs',
          code: 'S1_V6GyP5ym',
          type: 'game',
        },
        {
          name: 'Algerian Solitaire',
          code: 'rJu76zkD917',
          type: 'game',
        },
        {
          name: 'Dragon Annihilation',
          code: 'PdIZyZNAe',
          type: 'game',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'ଫ୍ରି ଅନଲାଇନ୍ ଗେମ୍ସ ମିତ୍ରମାନଙ୍କ ସହେ ଖେଳିବା ପାଇଁ କଣ କଣ ଅଛି?',
    body: {
      text: [],
      list: [
        {
          name: 'Ludo with Friends',
          code: 'SkhljT2fdgb',
          type: 'game',
        },
        {
          name: 'ZUNO',
          code: 'ByQxJnp7qRB',
          type: 'game',
        },
        {
          name: 'Tic Tac Toe',
          code: 'H1WmafkP9JQ',
          type: 'game',
        },
        {
          name: 'Ludo Dash',
          code: 'SJRX12TXcRH',
          type: 'game',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'ପୋପୁଲାର ଅନଲାଇନ୍ ଗେମ୍ସ ର ସବୁଠାରୁ ଜଣାଶୁଣା ଶୈଳୀ କଣ କଣ?',
    body: {
      text: [],
      list: [
        {
          name: 'କ୍ରେଜି ଖେଳ',
          nameEn: 'Crazy games',
          code: '10',
          type: 'tag',
        },
        {
          name: 'ବୋର୍ଡ ଖେଳ',
          nameEn: 'Board games',
          code: '11',
          type: 'tag',
        },
        {
          name: 'ଅ୍ୟାଡଭେଞ୍ଚର୍ ଖେଳ',
          nameEn: 'Adventure games',
          code: '14',
          type: 'tag',
        },
        {
          name: 'ପଜଲ୍ ଖେଳ',
          nameEn: 'Puzzle games',
          code: '8',
          type: 'tag',
        },
        {
          name: 'ଶୁଟିଂ ଖେଳ',
          nameEn: 'Shooting games',
          code: '2',
          type: 'tag',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: 'Gamezop କ’ଣ?',
    body: {
      text: [
        `Gamezop ହେଉଛି ଏକ ପ୍ଲଗ୍-ଅ୍ୟାଣ୍ଡ-ପ୍ଲେ ଗେମିଙ୍ଗ ପ୍ଲାଟଫର୍ମ, ଯାହା ଅପ୍ଲିକେସନ୍ ଏବଂ ୱେବସାଇଟ୍‌ଗୁଡ଼ିକୁ ସରଳ ଭାବରେ କ୍ୟାଜୁଆଲ୍ ଗେମ୍ସ ଇନ୍ଟିଗ୍ରେଟ୍ କରିବା ଜରିଆରେ ଉପଭୋକ୍ତା ଆନ୍ଦୋଳନ (User Engagement) ବୃଦ୍ଧି କରିବାରେ ସହାୟତା କରେ। ଗେମିଙ୍ଗ ପରିଧିରୁ ଉର୍ଦ୍ଧ୍ବରେ ଯାଇ, Gamezop ଏକାଧିକ ବିଶେଷ ପ୍ଲାଟଫର୍ମ‌ ଚଲାଉଛି: Quizzop ଇଣ୍ଟରାକ୍ଟିଭ୍ ଟ୍ରିଭିଆ ଓ କ୍ବିଜ୍ ପାଇଁ, Astrozop ଜ୍ୟୋତିଷ ଜ୍ଞାନ ଓ ପୂର୍ବାନୁମାନ ପାଇଁ, Criczop ଲାଇଭ୍ କ୍ରିକେଟ୍ ସ୍କୋର୍ ଓ ଅପଡେଟ୍ ପାଇଁ, ଏବଂ Feedzop ବିଶିଷ୍ଟ ଖବର ସଂଗ୍ରହ ପାଇଁ। ଏକସାଥିରେ, ଏହି ସମସ୍ତ ପ୍ଲାଟଫର୍ମ‌ ଏକ ବିଭିନ୍ନ ପ୍ରେକ୍ଷକମାନଙ୍କର ଆସକ୍ତିକୁ ଜୋଗାଇବା ପାଇଁ ଏକ ବିବିଧ ଧରଣର କଣ୍ଟେଣ୍ଟ ସମାଧାନ ପ୍ରଦାନ କରିଥାଏ।`,
        `8,000+ ଇନ୍ଟିଗ୍ରେସନ୍ ଓ 70+ ଦେଶରେ ବିସ୍ତୃତ ଉପସ୍ଥିତି ସହିତ, Gamezop ଓ ଏହାର ସମ୍ବନ୍ଧିତ ପ୍ଲାଟଫର୍ମ‌ ଯଥା Amazon, Samsung Internet, Snap, Tata Play, AccuWeather ଓ Paytm ପରି ବିଶ୍ୱସ୍ତ ବ୍ରାଣ୍ଡ‌ମାନଙ୍କ ଦ୍ଵାରା ବିଶ୍ୱସ୍ତ ହୋଇଛି। ଏହି ସମାଧାନଗୁଡ଼ିକ ଉପଭୋକ୍ତା ଆନ୍ଦୋଳନକୁ ବୃଦ୍ଧି କରିବା ସହିତ ନୂତନ ବିଜ୍ଞାପନ ରେଭେନ୍ୟୁ ଅବସରକୁ ଖୋଲିଥାଏ। ଇନ୍ଟିଗ୍ରେସନ୍ ପ୍ରକ୍ରିୟା କେବଳ 30 ମିନିଟ୍ ନିଆଏ ଏବଂ ଏହା ଏକ ସରଳ ପ୍ରକ୍ରିୟା ଯାହା ଅପ୍ ଏବଂ ୱେବସାଇଟ୍‌ଗୁଡ଼ିକୁ ଗେମ୍ସ, କ୍ୱିଜ୍, ଜ୍ୟୋତିଷ, କ୍ରିକେଟ୍ ଏବଂ ଖବର ସହିତ ନୂତନ କଣ୍ଟେଣ୍ଟ ପ୍ରଦାନ କରିବାର ସୁଯୋଗ ଦେଇଥାଏ।`,
      ],
      list: [],
    },
    initalState: 'initial_open',
  },
]

const FaqData: TFaqSection = {
  headTag: 'h2',
  headTitle: 'FAQs',
  faqs: [
    {
      tag: 'h3',
      title: 'ମୁଁ ଡାଉନଲୋଡିଂ କିମ୍ବା ଇନସ୍ଟଲିଂ କରିବା ବିନା ଫ୍ରି ଗେମ୍ସ ଖେଳିପାରିବି କି?',
      body: ['ହଁ, ଆପଣ ଡାଉନଲୋଡିଂ କିମ୍ବା ଇନସ୍ଟଲିଂ କରିବା ବିନା ଫ୍ରି ଗେମ୍ସ ଖେଳିପାରିବେ।'],
    },
    {
      tag: 'h3',
      title: 'ମୁଁ ଖେଳିବା ପାଇଁ ସାଇନ୍ ଅପ୍ କରିବା ଆବଶ୍ୟକ କି?',
      body: [
        'ନାହିଁ, ଆପଣକୁ Gamezop.com ରେ ଗେମ୍ସ ଖେଳିବା ପାଇଁ ସାଇନ୍ ଅପ୍ କରିବା ଆବଶ୍ୟକ ନାହିଁ। କୌଣସି ରେଜିସ୍ଟ୍ରେସନ୍ ଛାଡ଼ି ସହଜରେ ଖେଳା ଆରମ୍ଭ କରନ୍ତୁ।',
      ],
      links: {
        'Gamezop.com': 'https://www.gamezop.com/or',
      },
    },
    {
      tag: 'h3',
      title: 'ଅନଲାଇନ୍ ଗେମ୍ସ ଖେଳିବା ସୁରକ୍ଷିତ କି?',
      body: [
        'ହଁ, ଏକ ସର୍ବସ୍ତୁତିଯୋଗ୍ୟ ପ୍ଲାଟଫର୍ମ ଯଥା Gamezop ରେ ଅନଲାଇନ୍ ଗେମ୍ସ ଖେଳିବା ସୁରକ୍ଷିତ। ଆମର ଗେମ୍ସ ଡାଉନଲୋଡ୍ ଆବଶ୍ୟକ କରେ ନାହିଁ, ଯାହା ମାଲୱେର୍ ଝୁମ୍କକୁ କମାଇ ଦେଉଛି। ଆମେ ଉପଭୋକ୍ତା ସୁରକ୍ଷାରେ ଗୁରୁତ୍ୱ ଦେଇ ଆପଣଙ୍କୁ ଏକ ସୁରକ୍ଷିତ ଗେମିଙ୍ଗ ଅଭିଜ୍ଞତା ଦେବାକୁ ନିଶ୍ଚିତ କରୁଛୁ।',
      ],
    },
    {
      tag: 'h3',
      title: 'ଫ୍ରି ଗେମ୍ସ ସତରେ ଫ୍ରି କି?',
      body: [
        'ହଁ, ଫ୍ରି ଗେମ୍ସ Gamezop ରେ ପୁରାପୁରି ଫ୍ରି ଖେଳାଯାଏ। କିନ୍ତୁ, ଏହି ଗେମ୍ସ ପ୍ଲାଟଫର୍ମକୁ ସମର୍ଥନ କରିବା ପାଇଁ ବିଜ୍ଞାପନ୍ ଦେଖାଇ ଥାଏ।',
      ],
    },
    {
      tag: 'h3',
      title: 'ଅନଲାଇନ୍ ରେ ବୃଦ୍ଧମାନଙ୍କ ପାଇଁ ଫ୍ରି ଗେମ୍ସ ଅଛି କି?',
      body: [
        'ହଁ, ଆମ ପାଖରେ ବୃଦ୍ଧମାନଙ୍କ ପାଇଁ ଫ୍ରି ଗେମ୍ସ ଅଛି, ଯାହାକି ଅନଲାଇନ୍ ରେ ଖେଳାଯାଇପାରେ। ଏଥିରେ Sudoku Classic, Solitaire Gold, Chess Grandmaster, ଏବଂ ଅନ୍ୟାନ୍ୟ ଶାମିଲ ଅଛି।',
      ],
      links: {
        'Sudoku Classic': {
          type: 'game',
          name: 'Sudoku Classic',
          code: 'SJgx126Qc0H',
        },
        'Solitaire Gold': {
          type: 'game',
          name: 'Solitaire Gold',
          code: 'rkPlk2T7qAr',
        },
        'Chess Grandmaster': {
          type: 'game',
          name: 'Chess Grandmaster',
          code: 'rkAXTzkD5kX',
        },
      },
    },
  ],
}

export default {
  meta: MetaData,
  info: InfoData,
  faq: FaqData,
}
